import { render, staticRenderFns } from "./BuildingHeader.vue?vue&type=template&id=59424f74&scoped=true&"
import script from "./BuildingHeader.vue?vue&type=script&lang=js&"
export * from "./BuildingHeader.vue?vue&type=script&lang=js&"
import style0 from "./BuildingHeader.vue?vue&type=style&index=0&id=59424f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59424f74",
  null
  
)

export default component.exports